import React, { forwardRef, useRef, useEffect, useCallback } from 'react';
import { Input } from 'antd';
import {
  UploadAndViewImage,
  UploadAndViewPdf,
  UploadAndViewHtml,
} from '@components';
import { useLocation } from 'react-router-dom';
// import LinkInput from '@components/linkInput/linkInput';
import { INTEGRATION_TYPES } from '@model';
import TextContainerInlineInput from '@components/textContainerModal/TextContainerInlineInput';
import LinkEditorPopup from '@modules/projects/integrationHub/manageModules/manageMForm/agGridComponent/linkEditorPopup';
import { isHtmlModuleEnabled } from '@utils/htmlModuleConfig';
const { TextArea } = Input;

let activeId = '';
const setCaretPositionEnd = (elementId) => {
  const element = document.getElementById(elementId);
  const pos = element?.value?.length || 0;
  element.setSelectionRange(pos, pos);
};

const ExtendableTextArea = forwardRef(
  (
    {
      shouldExtend,
      autoSize,
      uploadPDFAPI,
      onSectionSetting = false,
      disabled,
      formChange = () => {},
      ...props
    },
    ref,
  ) => {
    const location = useLocation();
    const onProjectCreating = location.pathname?.includes(
      '/create/moduleSetting',
    );
    const onSystemSetting = location.pathname?.includes(
      '/settings/systemModule',
    );
    const onProjectHome = location.pathname?.includes('/project-detail');
    const onMultisection = location.pathname?.includes('/multiSectionLink');
    const onSectionSorter = onSectionSetting || onProjectHome || onMultisection;

    const inputRef = useRef(null);
    if (shouldExtend) {
      activeId = document.activeElement.id;
    }
    const rowType = props.formInstance?.getFieldValue?.([
      props.rowName,
      props.rowIndex,
    ])?.type;
    useEffect(() => {
      if (activeId === inputRef.current?.props?.id) {
        inputRef.current.focus();
        setCaretPositionEnd(activeId);
      }
    }, [shouldExtend]);

    useEffect(
      () => () => {
        activeId = '';
      },
      [],
    );
    const changeLink = (projectId, id) => {
      const formData = props.formInstance.getFieldsValue();
      const value =
        onSectionSorter || !id
          ? id
          : `/project/integrationModuleWithTab/${projectId}/pdf/${id}`;
      formData[props.rowName][props.rowIndex].link = value;
      props.formInstance.setFieldsValue(formData);
      props.onChange && props.onChange(value);
      formChange();
    };

    const onTextAreaChange = useCallback(
      (v) => {
        const formData = props.formInstance.getFieldsValue();
        if (
          onProjectCreating &&
          typeof formData[props.rowName][props.rowIndex].isFromSystemModule ===
            'boolean'
        ) {
          formData[props.rowName][props.rowIndex].isFromSystemModule = false;
          props.formInstance.setFieldsValue(formData);
        }

        moreProps.onChange && moreProps.onChange(v);
        formChange();
      },
      [props.rowName, props.rowIndex],
    );

    const changeImageLink = (path) => {
      const formData = props.formInstance.getFieldsValue();
      formData[props.rowName][props.rowIndex].link = path !== '' ? path : '';
      if (
        onProjectCreating &&
        typeof formData[props.rowName][props.rowIndex].isFromSystemModule ===
          'boolean'
      ) {
        formData[props.rowName][props.rowIndex].isFromSystemModule = false;
      }
      props.formInstance.setFieldsValue(formData);
      props.onChange && props.onChange(path);
      formChange();
    };

    const changeHtmlLink = (fileUrl) => {
      const formData = props.formInstance.getFieldsValue();
      formData[props.rowName][props.rowIndex].link =
        fileUrl !== '' ? fileUrl : '';
      if (
        onProjectCreating &&
        typeof formData[props.rowName][props.rowIndex].isFromSystemModule ===
          'boolean'
      ) {
        formData[props.rowName][props.rowIndex].isFromSystemModule = false;
      }
      props.formInstance.setFieldsValue(formData);
      props.onChange && props.onChange(fileUrl);
      formChange();
    };
    const onTextContainerIdChange = (v) => {
      const formData = props.formInstance.getFieldsValue();
      formData[props.rowName][props.rowIndex].link = v;
      if (onProjectCreating) {
        formData[props.rowName][props.rowIndex].isTemplate = true;
      }
      props.formInstance.setFieldsValue(formData);
      props.onChange && props.onChange(v);
      formChange();
    };
    const textContainerDisabled =
      rowType === INTEGRATION_TYPES.TEXT_CONTAINER && onSectionSorter;
    const shoudlDisabled =
      disabled ||
      textContainerDisabled ||
      [INTEGRATION_TYPES.CHART].includes(rowType);

    const moreProps = { ...props };
    if (rowType?.includes('powerbi') && props.id.includes('link')) {
      moreProps.placeholder = 'Insert a PowerBI Dashboard URL';
      // return <LinkInput linkLabel="PowerBI Link" {...props} />;
    }
    if (
      ['text', 'regular', 'other'].includes(rowType) &&
      props.id.includes('link')
    ) {
      moreProps.placeholder = 'Insert an External URL';
      // return <LinkInput linkLabel="External Link" {...props} />;
    }
    if (rowType === 'pdf' && props.id.includes('link')) {
      return (
        <UploadAndViewPdf
          {...props}
          changeLink={changeLink}
          shouldgetrReportPDF={onSectionSorter}
          uploadAPI={uploadPDFAPI}
        />
      );
    }
    if (rowType?.includes('image') && props.id.includes('link')) {
      return (
        <UploadAndViewImage {...props} changeImageLink={changeImageLink} />
      );
    }
    if (rowType === INTEGRATION_TYPES.HTML && props.id.includes('link')) {
      if (isHtmlModuleEnabled()) {
        return <UploadAndViewHtml {...props} changeHtmlLink={changeHtmlLink} />;
      }
      return (
        <TextArea
          disabled
          placeholder="Not Applicable"
          className="textarea-extendable link-input-disabled"
        />
      );
    }
    if (
      rowType === INTEGRATION_TYPES.TEXT_CONTAINER &&
      props.id.includes('link') &&
      // (onSystemSetting || onProjectCreating)
      !onProjectHome &&
      !onMultisection
    ) {
      return (
        <TextContainerInlineInput
          {...props}
          onChange={onTextContainerIdChange}
          isTemplate={onSystemSetting || onProjectCreating}
          onProjectCreating={onProjectCreating}
        />
      );
    }
    if (rowType === 'widget' || rowType === 'multiSection') {
      return (
        <TextArea
          disabled
          placeholder="Not Applicable"
          className="textarea-extendable link-input-disabled"
        />
      );
    }
    if (shoudlDisabled) {
      return (
        <TextArea
          disabled
          placeholder="Not Applicable"
          className="textarea-extendable link-input-disabled"
        />
      );
    }

    return (
      <LinkEditorPopup
        ref={inputRef}
        {...moreProps}
        autoSize={autoSize}
        onChange={onTextAreaChange}
      />
    );
  },
);
export default ExtendableTextArea;
